// @ts-check
/**
 * @file EmptyCockpitCTA.jsx
 * @location src/components/onboarding/EmptyCockpitCTA.jsx
 * @role ManagerTasksPage 의 빈 콕핏 상태 (`S.tasks.length === 0`) 안내.
 *   실제 발신은 상단 「업무 할당」 버튼이 담당 — 중복 진입점 방지로 여기엔 버튼 없음(안내만).
 */

export function EmptyCockpitCTA() {
  return (
    <div className="empty-cockpit" role="region" aria-label="업무 시작 방법">
      <p>위쪽 「업무 할당」에서 첫 업무를 할당해 팀과 업무 흐름을 만들어 보세요.</p>
    </div>
  );
}
